import HospitalsSelector from '../adminDashboard/HospitalsSelector';
import Button from '../ui/Button';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { createNewHospital, getCitiesOptionslist } from '../../api/hospitalsAPI';

import './NewHospitalForm.scss';
import { useState } from 'react';
import Loader from '../ui/Loader';

const AddHospital = ({
	title,
	subtitle,
	acceptLabel,
	declineLabel,
	onAccept,
	onDecline
}) => {
	const [confirmCreation, setConfirmCreation] = useState(false);
	const [citySelector, setCitySelector] = useState(null);
	const queryClient = useQueryClient();

	const { isLoading, error, data} = useQuery({
		queryKey:['new-hospital-cities'],
		queryFn: getCitiesOptionslist,
		retry: false,
		staleTime: 3000000 //5 minutes to refetch
	})
	const mutation = useMutation({
		mutationFn: createNewHospital,
		onSuccess: () => {
			cancelCreationHandler()
			onAccept()
			queryClient.invalidateQueries('hospitals-list')
			console.log('Hospital Submitted');
			
		},
		onError:()=>{
			console.log('The Hospital not saved');
		}
	});

	const handleSubmit = (event) => {
		event.preventDefault();
		const formData = new FormData(event.target);
		const data = {
		  name: formData.get('name'),
		  state: formData.get('state'),
		  normalcare: formData.get('normalcare'),
		  sponsored: formData.get('sponsored'),
		  nonbillable: formData.get('nonbillable'),
		  cityId: formData.get('city')
		};
		console.log(data)
		mutation.mutate(data);
	  };

	const cancelCreationHandler = () =>{
		setConfirmCreation(false)
	}
	
	if (isLoading) return <Loader/>;
	return (
		<form onSubmit={handleSubmit} className='new-hospital-container'>
			<section>
				<header>
					<h2>{title}</h2>
				</header>
			</section>
			<div className='confirmation-Warning-subtitle'>
				<p>{subtitle}</p>
			</div>
            <div className='info-container'>
				<div className='name-container'>
					<div className='hospital-name'>
						<p>Name*</p>
						<input type="text" id='name' placeholder='Hospital' required name='name'/>
					</div>
				</div>
				<div className='city-info-container'> 
					<div className='hospital-name'>
						<p>State*</p>
						<input type="text" id='state' placeholder='State' required name='state'/>
					</div>
					<div className='hospital-name'>
						<p>City*</p>
						<HospitalsSelector data={data.data.cities} onHospitalSelected={setCitySelector} name='city' />
					</div>
				</div>
				<div className='personalized-info-container'>
					<div className='hospital-name'>
						<p>Personalized name for Normal of Care*</p>
						<input type="text" id='normalcare' placeholder='By default "N"' required name='normalcare'/>
					</div>
					<div className='hospital-name'>
						<p>Personalized name for Sponsored*</p>
						<input type="text" id='sponsored' placeholder='By default "S"' required name='sponsored'/>
					</div>
					<div className='hospital-name'>
						<p>Personalized name for Non Billable*</p>
						<input type="text" id='nonbillable' placeholder='By default "N/B"' required name='nonbillable'/>
					</div>
				</div>
            </div>
			<footer className='confirmation-Warning-controllers'>
                <Button
					className='secondary-button'
					onClick={onDecline}
				>
					Cancel
				</Button>
				<Button
					type='submit'
					className='primary-button'
					disabled={mutation.isLoading}
					onDismiss={cancelCreationHandler}	
				>
					{!mutation.isLoading ? 'Create' : 'Loading'} 
				</Button>

			</footer>
		</form>
	);
};
export default AddHospital;
